import { useHydrateAtoms } from 'jotai/react/utils';
import { queryClientAtom } from 'jotai-tanstack-query';
import { queryClientGlobal } from './query-client';

export const HydrateAtomsGlobal = ({ children }: { children: JSX.Element }) => {
  useHydrateAtoms([[queryClientAtom, queryClientGlobal]]);
  return children;
};
